// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'actions';
import ResultsActionButton from './ResultsActionButton';

class ResultsShareButton extends Component {
  onClick = () => {
    const { currentResult, openModal } = this.props;
    const resultsLink = `${window.location.origin}/results/${currentResult}`;
    openModal('Share', { className: 'ShareModal', resultsLink });
  };

  render() {
    return (
      <ResultsActionButton onClick={this.onClick} className="share">
        <span>Share</span>
        <span className="results-text">&nbsp;Results</span>
      </ResultsActionButton>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    currentResult: state.currentResult,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: actions.openModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsShareButton);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsShareButton.js